<template>
	<div id="app">
	  <pageHeader></pageHeader>
		<router-view />
          <pageFooter></pageFooter>
		<!--<keep-alive  include="FileList">
     <router-view></router-view>
</keep-alive>-->
	</div>
</template>

<script>
import pageHeader from '@/components/pageheader'
import pageFooter from '@/components/pagefooter'
	export default {
	
  name: 'App',
  components: { pageHeader,pageFooter
  },
  data(){
return{
	  ukey:0,  
   
}
  },
  created(){
 this.getukeyVaule();
  },
 mounted() {
          window.addEventListener('unload', this.saveState)
},
methods: {
     getukeyVaule() {
        //  if(this.$route.query.ukey){
        //       this.ukey = this.$route.query.ukey
        //       localStorage.setItem('newukey',this.$route.query.ukey)
        //     }
        
    if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
    this.ukey = 0
    } else {
    this.ukey = localStorage.getItem('newukey')
    
        }
		},

       saveState() {
          sessionStorage.setItem('state', JSON.stringify(this.$store.state))
       }
},


	}
</script>

<style >

	/*#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
    }*/
  
  
</style>


// WEBPACK FOOTER //
// src/App.vue